import ListColumnModel from '@/modules/base/model/list-column-model'
import getStateInfo from '@/modules/offer/helpers/getStateInfo'

export default class OfferListColumnModel extends ListColumnModel {
  constructor(data) {
    super(data)

    this.displayed = data.displayed
    this.setColumnSpecificProperties()
  }

  setColumnSpecificProperties() {
    switch (this.name) {
      case 'totalGross':
      case 'totalNet':
      case 'total': {
        this.setCurrencyType()
        this.aggFunc = 'sum'
        break
      }
      case 'state': {
        this.cellRenderer = 'stateCellRenderer'
        this.filter = false
        this.comparator = (valueA, valueB) => {
          const aVal = getStateInfo(valueA)
          const bVal = getStateInfo(valueB)
          return aVal.localeCompare(bVal)
        }
        this.filterParams = {
          valueFormatter: (param) => {
            return getStateInfo(param.value)
          },
        }
        this.getQuickFilterText = (params) => {
          return params.node?.data?.stateLabel || params.value
        }
        break
      }
      case 'lastEmailSentAt':
      case 'date': {
        this.setDateType()
        break
      }
      case 'createdAt':
      case 'updatedAt':
      {
        this.setDateTimeType()
        break
      }
      case 'tags': {
        this.setTagType()
        break
      }
      default: { return }
    }
  }
}
